import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { isBigBullet } from './helpers';
import { StepperItem } from './StepperItem';
import { StepperWrapper } from './StepperWrapper';
var Stepper = _ref => {
  var {
    children,
    noStartPadding,
    UNSAFE_props
  } = _ref;
  var hasNoBigBullets = React.Children.toArray(children).every(child => /*#__PURE__*/React.isValidElement(child) && !isBigBullet({
    customBulletContent: child.props.customBulletContent,
    state: child.props.state
  }));
  return /*#__PURE__*/React.createElement(StepperWrapper, UNSAFE_props, React.Children.map(children, (child, i) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.isValidElement(child) && /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
    isLast: React.Children.count(children) === i + 1,
    noStartPadding: noStartPadding && hasNoBigBullets
  })))));
};
Stepper.displayName = 'Stepper';
Stepper.Item = StepperItem;
export { Stepper };
//# sourceMappingURL=index.js.map